export class Configuration {

  type!: string;

  terminal!: number; // station + handheld
  station = 1;
  handheld = 0;

  emv!: number;
  cd!: number;
  menu!: boolean;
  liquor!: boolean;
  inventory!: boolean;
  layout: boolean = true;
  merchant!: boolean;
  olo!: boolean;
  gift = new Array<string>();
  oloSetup = new Array<string>();

  public load(data: any): this {

    Object.assign(this, data);

    // Backwards compatibility
    if (data.station){
      this.terminal = data.station + (data.handheld ? data.handheld : 0);
    } else {
      this.station = data.terminal - (data.handheld ? data.handheld : 0);
    }

    this.gift = new Array<string>();

    if(data?.gift?.length > 0){

      if(Array.isArray(data.gift)){
        data?.gift
            ?.forEach(g => {
              this.gift
                  .push(g);
            });
      } else {
        this.gift
            .push(data.gift);
      }
    }

    this.oloSetup = new Array<string>();

    if(data?.oloSetup?.length > 0){

      if(Array.isArray(data.oloSetup)){
        data?.oloSetup
            ?.forEach(s => {
              this.oloSetup
                  .push(s);
            });
      } else {
        this.oloSetup
            .push(data.oloSetup);
      }
    }

    return this;
  }
}
